import { render, staticRenderFns } from "./LiveDetail.vue?vue&type=template&id=d0837bf0&scoped=true&"
import script from "./LiveDetail.vue?vue&type=script&lang=js&"
export * from "./LiveDetail.vue?vue&type=script&lang=js&"
import style0 from "./LiveDetail.vue?vue&type=style&index=0&id=d0837bf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0837bf0",
  null
  
)

export default component.exports